module.exports = __webpack_public_path__ + "assets/img/banner_adobeplayer.gif";